import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import both from '@/utils/storage'
import uuidv1 from 'uuid/v1'
import API from '@/utils/api'
import * as API_USER from '@/api/user'

// 设置uuid
let uuid = both.storage.get('uuid')
if (uuid.length == 0) {
  uuid = uuidv1()
  both.storage.set('uuid', uuid)
}

// 设置token
let token = both.storage.get('token')

// 设置user
let user = both.storage.get('user')

// 设置语言
let langCountry = both.storage.get('langCountry')
langCountry = langCountry.length == 0 ? 'en' : langCountry

export default new Vuex.Store({
  state: {
    // 基础设置
    site: {},
    currencyList: [],
    countryList: [],
    FAQ: {},
    uuid: uuid,
    API: API,
    token: token,
    user: user,
    langCountry: langCountry,
  },
  mutations: {
    site(state, obj) {
      state.site = obj
    },
    currencyList(state, list) {
      state.currencyList = list
    },
    countryList(state, list) {
      state.countryList = list
    },
    FAQ(state, item) {
      state.FAQ = item
    },
    token(state, item) {
      state.token = item
    },
    user(state, item) {
      state.user = item
    },
    langCountry(state, string) {
      state.langCountry = string
    }
  },
  actions: {
    site({commit}, obj = {}) {
      return new Promise((resolve, reject) => {
        commit('site', obj)
        resolve()
      })
    },
    currencyList({commit}, list = []) {
      return new Promise((resolve, reject) => {
        commit('currencyList', list)
        resolve()
      })
    },
    countryList({commit}, list = []) {
      return new Promise((resolve, reject) => {
        commit('countryList', list)
        resolve()
      })
    },
    FAQ({commit}, item = {}) {
      return new Promise((resolve, reject) => {
        commit('FAQ', item)
        resolve()
      })
    },
    token({commit}, item = {}) {
      return new Promise((resolve, reject) => {
        if (item.access_token_timeout) {
          item.access_token_timeout = new Date().getTime() + 1000 * item.access_token_timeout
          item.refresh_token_timeout = new Date().getTime() + 1000 * item.refresh_token_timeout
        }else{
          // 清除user信息
          commit('user', {})
        }
        both.storage.set('token', item)
        commit('token', item)
        resolve()
      })
    },
    user({commit}, item = {}) {
      return new Promise((resolve, reject) => {
        item.img = !!item.img ? item.img : '/image/morenHead.png'
        both.storage.set('user', item)
        commit('user', item)
        resolve()
      })
    },
    freshUser({commit}, item = {}) {
      return new Promise((resolve, reject) => {
        API_USER.getUserInfo().then(res=> {
          res.data.img = !!res.data.img ? res.data.img : '/image/morenHead.png'
          both.storage.set('user', res.data)
          commit('user', res.data)
          resolve(res)
        })
      })
    },
    langCountry({commit}, string = 'cn') {
		  return new Promise((resolve, reject) => {
        commit('langCountry', string)
        resolve(string)
	    })
  	}
  },
  modules: {
  },
  getters: {
    site: state => {
      return state.site
    },
    currencyList: state => {
      return state.currencyList
    },
    countryList: state => {
      return state.countryList
    },
    FAQ: state => {
      return state.FAQ
    },
    uuid: state => {
      return state.uuid
    },
    API: state => {
      return state.API
    },
    token: state => {
      return state.token
    },
    user: state => {
      return state.user
    },
  	langCountry: state => {
		  return state.langCountry
    }
  }
})
